import * as React from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../operations/queries/get-accessories-by-slug.js';
import '../../operations/queries/get-contact-lens-by-slug.js';
import '../../operations/queries/get-frames-by-slug.js';
import '../../operations/queries/get-solutions-by-slug.js';
import '../../operations/queries/get-sunglasses-by-slug.js';
import '../../operations/queries/get-ready-reader-by-slug.js';
import { GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER } from '../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../operations/queries/get-manufacturer-by-key.js';
import { mapCartDiscountToClient } from './map-to-client-cart-discount.js';

const useCartDiscountInternal = (promotionIdentifier)=>{
    const { isCartDiscountsEnabled  } = useFeatureToggles();
    const { data , loading , error  } = useQuery(GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER, {
        skip: !isCartDiscountsEnabled || !promotionIdentifier,
        variables: {
            promotionIdentifier: promotionIdentifier || ''
        }
    });
    if (error) {
        console.error(error);
    }
    return {
        loading,
        data
    };
};
/*
 * Query the cart discounts by promotion identifier
 */ const useCartDiscountsQuery = (promotionIdentifier, selectedQuantity)=>{
    const { loading , data  } = useCartDiscountInternal(promotionIdentifier);
    const cartDiscounts = React.useMemo(()=>{
        return mapCartDiscountToClient(data === null || data === void 0 ? void 0 : data.getCartDiscountsByPromotionIdentifier);
    }, [
        data
    ]);
    const activeDiscount = React.useMemo(()=>{
        if (!selectedQuantity) {
            return undefined;
        }
        // Sort discount from highest to lowest minimum quantity, then find the first match.
        // This is needed, because discounts are shown in the opposite order.
        const sortedDescendingDiscounts = [
            ...cartDiscounts
        ].sort((a, b)=>b.minimumQuantity - a.minimumQuantity
        );
        return sortedDescendingDiscounts.find((discount)=>selectedQuantity >= discount.minimumQuantity
        );
    }, [
        cartDiscounts,
        selectedQuantity
    ]);
    return {
        loading,
        cartDiscounts,
        activeDiscount
    };
};

export { useCartDiscountsQuery };
//# sourceMappingURL=use-cart-discounts-query.js.map
